<template lang="html">
  <div class="w-100 py-1">
    <b-dropdown toggle-class="border-0 p-0 bg-none m-md-2 text-dark">
      <template slot="button-content">
        <span>
          <span v-for="norm in norms" :key="norm.value">
            <span v-if="checkedNorm === norm.value" class="mr-1">{{ norm.text }}</span>
          </span>
        </span>
      </template>
      <div v-for="norm in norms" :key="norm.value">
        <b-dropdown-item v-if="norm.condition" @click="$bus.$emit('change-norm', norm.value, true)" class="dropdown-item-web-header">
          <span :class="checkedNorm === norm.value ? 'font-weight-bold text-green' : ''">{{ norm.text }}</span>
        </b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
// import {loadPage, reloadPage2} from './../../../helpers/routing'

export default {
  name: 'MobileNormPicker',
  props: {
    checkedNorm: {
      type: Number,
      default: 0
    },
    norms: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      menu: {},
      menuLinkList: null,
      options: [],
      selectedMenu: ''
    }
  },
}
</script>
